import React, {useEffect, useRef, useState} from "react";
import {Button, Dropdown, Menu, Modal, Spin, Switch, Tooltip} from "antd";
import {Link, useHistory, useLocation} from "react-router-dom";
import {
    DraggableMoveUpDownIco,
    DeleteIco,
    HeaderCreateTemplateArrowIco,
    HeaderCreateTemplatePlusIco, ModalCloseIco, CreateTemplateRightArrowIco, SpinnerIco
} from "../../../../../modules/CustomIcons";
import {
    changeTemplateSeq,
    getTemplatesByParams,
    Templates,
    upsertTemplate
} from "../../../../services/Transfers/Templates";

import { ReactSortable } from "react-sortablejs";
import {leftMenuToggle, saveTemplateSuccess } from "store/actions/home";
import {getCurrentCompany} from "../../../../services/user";
import {connect} from "react-redux";
import {trnTypes} from "../../../../../root/Routes/Routes";
import CustomTooltip from "components/Tooltip";
import DeleteTemplate from "components/DeleteTemplate";
import type { Scrollbar as BaseScrollbar } from 'smooth-scrollbar/scrollbar'
import { Scrollbar } from 'smooth-scrollbar-react'
import {useActions} from "hooks/useActions";
import { secureLocalStorageGet } from "../../../../helpers";
import { useTranslation } from "react-i18next";

const createTemplateVisibleReset={
    showStep1 : false,
    showStep2 : false,
    showStep3 : false
}



const CreateTemplateComponent:React.FC<any> = ({leftMenuStatus, companyData, loading, statusTemplate }) => {
    const {t} = useTranslation()

    const created_templates2=[
        {
            templateName : 'AZİPS',
            trnType: "AZIPS",
            templateId: null,
            active : false
        },
        {
            templateName : 'XÖHKS',
            trnType: "XOHKS",
            templateId: null,
            active : false
        },
        {
            templateName : t("home.budgetVAT"),
            trnType: "EDV",
            templateId: null,
            active : false
        },
        {
            templateName : t("home.budgetSTA"),
            trnType: "DXA",
            templateId: null,
            active : false
        },
        {
            templateName : t("transfers.anipayNonBudget"),
            trnType: "IPS_OTH",
            templateId: null,
            active : false
        },
        {
            templateName : t('transfers.aniPayVAT'),
            trnType: "IPS_VAT",
            templateId: null,
            active : false
        },
        {
            templateName : t('transfers.aniPaySTA'),
            trnType: "IPS_BDG",
            templateId: null,
            active : false
        },
        {
            templateName : t("transfers.internalToOwnAccount"),
            trnType: "OWN_ACCOUNT",
            templateId: null,
            active : false
        },
        {
            templateName : t("transfers.internalToOtherAccount"),
            trnType: "INTERNAL",
            templateId: null,
            active : false
        },
        {
            templateName : t("home.foreignCurrencyTransfer"),
            trnType: "SWIFT",
            templateId: null,
            active : false
        },
        {
            templateName : 'RUB',
            trnType: "SWIFT_RUB",
            templateId: null,
            active : false
        },
    ];

    const [createTemplateVisible, setCreateTemplateVisible] = useState(createTemplateVisibleReset);
    const [createTemplate2, setCreateTemplate2] = useState(created_templates2);
    const [showEmptyModal, setShowEmptyModal] = useState(false);
    const [favoriteTemplate, setFavoriteTemplate] = useState<Templates[]>();
    const [template, setTemplates] = useState<Templates[]>();
    const [clickedTemplate, setClickedTemplate] = useState('');
    const [subTemplates, setSubTemplates] = useState<Templates[]>();
    const [deleteTemplateModalVisible, setDeleteTemplateModalVisible] = useState(false);
    const [selectedTemplate, setSelectedTemplate]=useState<any>();
    const [visible, setVisible] = useState(false);
    const scrollbar = useRef<BaseScrollbar | null>(null)
    const [listCountTemplate, setListCountTemplate] = useState(0);
    const [loadingTemplate, setLoadingTemplate] = useState(false);
    const { saveTemplateSuccess } = useActions()
    const history=useHistory();
    const location = useLocation()

    const getTemplates = async () => {
      const data = await getTemplatesByParams();
       if (data) {
           let fav_templates = data?.filter(row => row.isFavorite === "Y");
           if(fav_templates !== undefined && fav_templates !== null && fav_templates.length > 0) {
               setShowEmptyModal(old_data => false);
           } else {
               setShowEmptyModal(old_data => true);
           }
           setFavoriteTemplate(old_data => fav_templates);
           let count = 0;
           let countTemplate = 0;
           for (let templatesKey in fav_templates) {
               let favTemplatesKey = fav_templates[templatesKey]
               if(favTemplatesKey?.templateName?.length > 32)
                   count += 32;
               else
                   count += favTemplatesKey.templateName?.length;
               if(count < 65) {
                   countTemplate += 1;
               }
           }
           setListCountTemplate(countTemplate > 5 ? 5 : countTemplate);
           setTemplates(old_data => data);
           for(let key in data) {
               let row=data[key];
               let new_one = createTemplate2.map(item => {
                   return {
                       ...item,
                       templateId: (item.trnType===row.trnType) ? row.templateId : null,
                       active : item.trnType===row.trnType
                   }
               });
               //setCreateTemplate2(old_data => new_one)
           }
       } else {
           setShowEmptyModal(old_data => true);
        }
    }

    useEffect(() => {
        if(!loading)
            getTemplates();

    }, [companyData, location.state, loading]);

    useEffect(() => {
        if(!loading && statusTemplate) {
            getTemplates();
            saveTemplateSuccess()
        }
    }, [statusTemplate]);

    const updateFavTemplateList = async () => {
        if(!loadingTemplate) {
            setLoadingTemplate(true)
            await subTemplates?.forEach(row => {
                upsertTemplate(row).then(res => {
                    //console.log(res)
                })
            })

            await getTemplates()
            setLoadingTemplate(false)
            history.push({
                state: Math.random()
            })
            closeAndOpenModal('showStep1')
        }

    }

    const updateMainTemplateList = async () => {

        await favoriteTemplate?.forEach((row, index) => {
            let req_data={
                templateId  : row.templateId,
                favoriteSeq : index + 1
            }

            changeTemplateSeq(req_data).then(res => {
                //console.log(res)
            })
        })

        closeAndOpenModal('closeAll')
    }

    const drop_down_menus = (
        <Menu style={{ width: 195 }} className='has_hover_dropdown header-dropdown-menu create_template_drop_down' >
            {
                favoriteTemplate?.slice(listCountTemplate, 100)?.map((row, index) => {
                    return (
                        <Menu.Item key={`create_template_${index}`} onClick={() => setVisible(!visible)}>
                            { row.templateName?.length > 32 ?
                                <CustomTooltip key={`temp_tooltip_${row.templateId}`} title={row.templateName} >
                                    <Link to={{
                                        pathname: trnTypes[row.trnType].url,
                                        state: row
                                    }}  >
                                        {row.templateName}
                                    </Link>
                                </CustomTooltip>
                                : <Link to={{
                                    pathname: trnTypes[row.trnType].url,
                                    state: row
                                }}  >
                                    {row.templateName}
                                </Link>
                            }
                        </Menu.Item>
                    )
                })
            }

        </Menu>
    )

    const first_modal_class=showEmptyModal ? 'manage_template_modal_empty' : '';

    const first_modal_footer=(
        <>
            <div className='flex justify_between align_center'>
                <Button type="primary" className='modal_ok_btn' onClick={() => { closeAndOpenModal('showStep2') }} disabled={template?.length === 0}>{t("templates.add")}</Button>
                <Button type="primary" className='modal_ok_btn ' onClick={updateMainTemplateList} disabled={showEmptyModal}>{t("accountStatement.apply")}</Button>
            </div>
        </>
    )

    const second_modal_footer =(
        <>
            <div className='flex justify_end align_center'>
                <Button type="button" className='modal_cancel_btn  ' onClick={() => { closeAndOpenModal('showStep1') }} >{t("templates.back")}</Button>
            </div>
        </>
    )

    const third_modal_footer = (
        <>
            <div className='flex justify_end align_center'>
                <Button type="button" className='modal_cancel_btn  ' onClick={() => { closeAndOpenModal('showStep2') }} >{t("templates.back")}</Button>
                {loadingTemplate ?
                    <div style={{width: '100px', display: 'flex', alignItems: 'center', justifyContent: 'center'}} className={'template_footer'}>
                        <div className='ant-btn exportLoadingdiv transfer_loading'><Spin indicator={<SpinnerIco/>}/>
                        </div>
                    </div> :
                    <Button type="primary" className='modal_ok_btn ' onClick={updateFavTemplateList}  >{t("accountStatement.apply")}</Button>
                }
            </div>
        </>
    )

    const closeAndOpenModal = (next_step : string) => {

        // setShowEmptyModal(false);

        setCreateTemplateVisible(old_data => ({
            ...createTemplateVisibleReset
        }));

        if (next_step!=='closeAll'){
            setCreateTemplateVisible(old_data => ({
                ...createTemplateVisibleReset,
                [next_step] : true
            }));
        }
    }

    // @ts-ignore
    const onChange = (checked, index) => {

        //subTemplates?[index].isFavorite="Y";

        let update_list=subTemplates?.map((row, row_index) => ({
            ...row,
            isFavorite : row_index===index ? (checked) ? 'Y' : 'N' : row.isFavorite
        }));

        setSubTemplates([...update_list]);
    }

    const showStep3Popup = async (row, name) => {
        const get_sub_templates=await getTemplatesByParams(row.trnType);
        let fav_templates = get_sub_templates;
        setClickedTemplate(old_data => name.templateName);
        setSubTemplates(old_data => fav_templates);

        closeAndOpenModal('showStep3')
    }

    const templateDelete = (row : any) => {
        row.isFavorite="N";
        setDeleteTemplateModalVisible(old_data => true);
        const line = {
            customerNo: row.customerNo,
            favoriteSeq: row.favoriteSeq,
            isFavorite: "N",
            templateId: row.templateId,
            templateName: row.templateName,
            trnType: row.trnType,
            userName: row.userName,
            trnData: row.trnData
        }
        setSelectedTemplate(old_data => line)
    }

    const updateTemplateOrder = (newState : any) => {

        let count = 0;
        let countTemplate = 0;
        for (let templatesKey in newState) {
            let favTemplatesKey = newState[templatesKey]
            if(favTemplatesKey?.templateName?.length > 32)
                count += 32;
            else
                count += favTemplatesKey?.templateName?.length;
            if(count < 65) {
                countTemplate += 1;
            }
        }
        setListCountTemplate(countTemplate > 5 ? 5 : countTemplate);
        setFavoriteTemplate(old_data => newState)
    }

    const controlDropdownMenu = () => {
        setVisible(false)
    };

    useEffect(() => {
        const layoutScroll = document.getElementById("layout_scroll");
        if (typeof layoutScroll !== 'undefined') {
            layoutScroll?.addEventListener('scroll', controlDropdownMenu);

            return () => {
                layoutScroll?.removeEventListener('scroll', controlDropdownMenu);
            };
        }
    });

    return (
        <>
            <div className={`full_h header_left_in flex align_center ${favoriteTemplate?.length===0 ? 'justify_center' : ''}`}>
                {
                    favoriteTemplate &&
                    <div className='full flex full_h align_center  template_slider_box'>

                        <ul className='template_carousel'>
                            {
                                favoriteTemplate?.slice(0, listCountTemplate)?.map((row, index) => {
                                    return (
                                        <li key={`temp_${row.templateId}`}>
                                            { row.templateName?.length > 32 ?
                                                <CustomTooltip key={`temp_tooltip_${row.templateId}`} title={row.templateName} >
                                                    <Link key={`item_${index}`} to={{
                                                        pathname: trnTypes[row.trnType].url,
                                                        state: row
                                                    }} className='template_link_btn' >
                                                        {row.templateName}
                                                    </Link>
                                                </CustomTooltip>
                                                : <Link key={`item_${index}`} to={{
                                                    pathname: trnTypes[row.trnType].url,
                                                    state: row
                                                }}  className='template_link_btn'>
                                                    {row.templateName}
                                                </Link>
                                            }
                                        </li>
                                    )
                                })
                            }
                        </ul>

                        {
                            favoriteTemplate?.length > listCountTemplate &&
                            <Dropdown overlay={drop_down_menus} trigger={`click`} placement="bottomRight" visible={visible} onVisibleChange={() => setVisible(!visible)} >
                                <Button type={'button'} className={` create_template_drop_down_ico`} icon={<HeaderCreateTemplateArrowIco />} />
                            </Dropdown>
                        }
                    </div>
                }

                <Tooltip
                    overlayClassName={``}
                    placement={"bottom"}
                    title={t("templates.addTemplatesToFavourite")}
                >
                    <Button
                        onClick={() => { getTemplates(); setCreateTemplateVisible({...createTemplateVisibleReset, showStep1 : true}) }}
                        className='add_template_btn plus_button flex align_center justify_center'
                        shape="circle"
                        type="primary"
                        icon={<HeaderCreateTemplatePlusIco />}
                    />
                </Tooltip>



                {/*Modal 1*/}
                <Modal
                    title={t("templates.favoriteTemplates")}
                    closeIcon={<ModalCloseIco />}
                    centered
                    visible={createTemplateVisible.showStep1}
                    onOk={() => setCreateTemplateVisible({...createTemplateVisibleReset})}
                    okText={t("accountStatement.apply")}
                    okButtonProps={{className: 'modal_ok_btn'}}
                    onCancel={() => setCreateTemplateVisible({...createTemplateVisibleReset})}
                    cancelText={'Ləğv et'}
                    cancelButtonProps={{className: 'modal_cancel_btn'}}
                    width={730}
                    // manage_template_modal
                    className={`manage_faster_menus manage_template_modal_step_1 swift_modal form_next_modal transfer_own_account transfer_own_account ${first_modal_class}`}
                    keyboard={false}
                    focusTriggerAfterClose={false}
                    footer={first_modal_footer}
                >

                        {
                            showEmptyModal ?
                            <>
                                <p>{t("templates.noTemplate")}</p>
                            </> :

                                <Scrollbar
                                    ref={scrollbar}
                                    plugins={{
                                        disableScroll: { direction: 'x' },
                                    }}
                                    alwaysShowTracks={true}
                                >
                                    <div>
                                        <ul className='faster_menus_draggable created_templates_draggable created_templates_draggable1  flex direction_column' >
                                        <ReactSortable list={favoriteTemplate} setList={updateTemplateOrder}>
                                            {favoriteTemplate?.map((row, index) => {
                                                let li_class=index < 5 ? 'has_hover' : '';
                                                return (
                                                    <li key={`draggable_li_${index}`} className={li_class}>
                                                        <div className='flex align_center'>
                                                            <a href="#">
                                                                <DraggableMoveUpDownIco/>
                                                            </a>
                                                            <p>
                                                                {row.templateName}
                                                                <span>{trnTypes[row.trnType].title}</span>
                                                            </p>
                                                        </div>
                                                        <Button type="link" onClick={() => templateDelete(row)} danger icon={<DeleteIco/>}/>
                                                    </li>
                                                )
                                            })}

                                        </ReactSortable>
                                    </ul>
                                    </div>
                                </Scrollbar>
                        }


                </Modal>


                {/* Modal 2 */}
                <Modal
                    title={t("templates.transferTypes")}
                    closeIcon={<ModalCloseIco />}
                    centered
                    visible={createTemplateVisible.showStep2}
                    onOk={() => setCreateTemplateVisible({...createTemplateVisibleReset})}
                    okText={t("accountStatement.apply")}
                    okButtonProps={{className: 'modal_ok_btn'}}
                    onCancel={() => setCreateTemplateVisible({...createTemplateVisibleReset})}
                    cancelText={'Ləğv et'}
                    cancelButtonProps={{className: 'modal_cancel_btn'}}
                    width={730}
                    className={'manage_faster_menus manage_template_modal  manage_template_modal_step_2 '}
                    keyboard={false}
                    focusTriggerAfterClose={false}
                    footer={second_modal_footer}
                >

                    <ul className='faster_menus_draggable created_templates_draggable created_templates_draggable2 flex direction_column' >
                        {createTemplate2.map((row, index) => {

                            let find_row=template?.find(temp => temp.trnType===row.trnType);
                            let li_class=find_row ? 'active' : 'passive'
                            return (
                                <li
                                    className={li_class}
                                    key={`draggable_li_${index}`}
                                    onClick={() => { find_row ? showStep3Popup(find_row, row) : null }}
                                >

                                    <div className={'flex full align_center justify_between'} >
                                        {
                                            !find_row && <span className='passive_text_box'>{t("templates.noTemplateForThisTransfer")}</span>
                                        }
                                        <p>{row.templateName}</p>
                                        <Button
                                            disabled={!find_row}
                                            type="ghost"
                                            className={'transparent'}
                                             icon={<CreateTemplateRightArrowIco className='created_temp_arrow_right' />}
                                        />
                                    </div>
                                </li>
                            )
                        })}
                    </ul>


                </Modal>


                {/* Modal 3 */}
                <Modal
                    title={t("home.templates")}
                    closeIcon={<ModalCloseIco />}
                    centered
                    visible={createTemplateVisible.showStep3}
                    onOk={() => setCreateTemplateVisible({...createTemplateVisibleReset})}
                    okText={t("accountStatement.apply")}
                    okButtonProps={{className: 'modal_ok_btn'}}
                    onCancel={() => setCreateTemplateVisible({...createTemplateVisibleReset})}
                    cancelText={'Ləğv et'}
                    cancelButtonProps={{className: 'modal_cancel_btn'}}
                    width={730}
                    className={'manage_faster_menus manage_template_modal  manage_template_modal_step_3 '}
                    keyboard={false}
                    focusTriggerAfterClose={false}
                    footer={third_modal_footer}
                >

                    <h3>{clickedTemplate}</h3>

                    <ul className='faster_menus_draggable created_templates_draggable created_templates_draggable3 flex direction_column' >
                        {subTemplates?.map((row, index) => {
                            let li_class=row.isFavorite==="Y" ? 'active' : 'passive'

                            return (
                                <li className={li_class} key={`draggable_li_${index}`} >
                                    <p>{row.templateName}</p>
                                    <Switch checked={row.isFavorite==="Y"} onChange={(e) => onChange(e, index)} />
                                </li>
                            )
                        })}
                    </ul>


                </Modal>

            </div>

            {
                deleteTemplateModalVisible && <DeleteTemplate
                    visible={deleteTemplateModalVisible}
                    onClose={setDeleteTemplateModalVisible}
                    templateIds={selectedTemplate}
                    isUpdate={true}
                    callBackApi={getTemplates}
                />
            }
        </>
    )
}

const mapDispatchToProps = { leftMenuToggle, saveTemplateSuccess }

const mapStateToProps = (state: any) => ({
    leftMenuStatus:  state.home.leftMenuStatus,
    companyData: (state.user &&  state.user.companyData.result) ?  state.user.companyData.result.customerNo  : getCurrentCompany(),
    loading: state.user.isCompChange,
    statusTemplate: state.home.statusTemplate
})

export default connect(mapStateToProps, mapDispatchToProps)(CreateTemplateComponent)
